query GetRequestsForFunding(
  $page: Int
  $limit: Int
  $search: String
  $formType: RequestForFundingFormTypeEnum
) {
  requestsForFunding(
    page: $page
    limit: $limit
    search: $search
    formType: $formType
  ) {
    collection {
      id
      formType
      primaryContactEmail
      program
      budget
      programCategory
      website
      currentBudget
      createdAt
      whatYourProgramDoes
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
